import PressArmorDescription from "../../../../src/courses/partials/services/pressarmor.mdx";
import * as React from 'react';
export default {
  PressArmorDescription,
  React
};